import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({}))

export const EmailInfo = styled('div', ({ $theme }) => ({
    margin: '2rem 0',
    fontSize: '10px',
    lineHeight: '18px',
    fontWeight: 400
}))

export const EmailInputContainer = styled('div', () => ({
    marginTop: '0.8rem'
}))
